import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Showcase } from "@/components/home/Showcase";
import { Bento } from "@/components/home/Bento";
import { Trust, ClosingCta } from "@/components/home/Trust";
import { Faq } from "@/components/home/Faq";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Hero />
      <Marquee />
      <Showcase />
      <Bento />
      <Trust />
      <Faq />
      <ClosingCta />
    </div>
  );
}
